export default __webpack_public_path__ + "static/media/srishti.a3fef39b.jpeg";